/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPieChart(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M11.25 2.002a.75.75 0 01.75-.75c6.462 0 10.75 5.386 10.75 10.75a.75.75 0 01-.75.75H12a.75.75 0 01-.75-.75v-10zm1.5.779v8.471h8.468c-.356-4.158-3.637-8.099-8.468-8.471zm-4.062-.249a.75.75 0 01-.388.988A9.25 9.25 0 1020.52 15.6a.75.75 0 011.38.584A10.75 10.75 0 117.7 2.144a.75.75 0 01.988.388z'
      />
    </svg>
  );
}

export default SvgPieChart;
